import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full max-w-[80%]" }
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-2 text-red-600 text-sm"
}
const _hoisted_4 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_5 = { class: "flex flex-row items-center gap-2" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex items-center justify-between p-4 rounded-lg border border-gray-200 w-full" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["aria-checked", "disabled"]
const _hoisted_10 = { class: "flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpertTags = _resolveComponent("ExpertTags")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.updateProgramLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary-purple" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Something went wrong. Please try again later. "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          innerHTML: _ctx.PAYOUT_HEART_ICON,
          class: "text-primary-purple w-6 h-6"
        }, null, 8, _hoisted_6),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex flex-col" }, [
          _createElementVNode("div", { class: "text-black font-inter text-base font-semibold normal-case leading-6" }, " Meeting duration ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
          _createElementVNode("span", { class: "text-zinc-800 text-sm font-medium" }, " Thank you payout only if meeting duration is more than 5 minutes ")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            role: "switch",
            "aria-checked": _ctx.payoutOnlyCallDurationMoreThan5,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePayoutSetting && _ctx.togglePayoutSetting(...args))),
            class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-violet-600 focus:ring-offset-2", 
              _ctx.payoutOnlyCallDurationMoreThan5 ? 'bg-violet-600' : 'bg-gray-200'
            ]),
            disabled: _ctx.updateProgramLoading
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["inline-block h-4 w-4 transform rounded-full bg-white transition-transform", 
                _ctx.payoutOnlyCallDurationMoreThan5
                  ? 'translate-x-6'
                  : 'translate-x-1'
              ])
            }, null, 2)
          ], 10, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_ExpertTags, {
          initialExpertTags: _ctx.expertTags,
          initialShowExpertTagsList: _ctx.showExpertTagsList,
          onUpdateExpertTags: _ctx.updateExpertTags,
          onSaveExpertTags: _ctx.saveExpertTags
        }, null, 8, ["initialExpertTags", "initialShowExpertTagsList", "onUpdateExpertTags", "onSaveExpertTags"])
      ])
    ])
  ]))
}